if (typeof beyondUpsellsSlider === 'undefined') {
  var beyondUpsellsSlider = null;
}

function destroySwiper() {
  if (beyondUpsellsSlider) {
    beyondUpsellsSlider.destroy(true, true);
    beyondUpsellsSlider = null;
  }
}

function initBeyondUpsellsSwiper() {
  const swiperElement = document.querySelector(".js-beyondupsells-init");
  
  if (!swiperElement) {
    destroySwiper();
    return;
  }

  // Conta quante slide ci sono
  const slides = swiperElement.querySelectorAll('.swiper-slide');
  if (slides.length === 0) {
    destroySwiper();
    return;
  }

  destroySwiper();

  // Doppio requestAnimationFrame per assicurarsi che il DOM sia stabile
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      const updatedElement = document.querySelector(".js-beyondupsells-init");
      if (!updatedElement) return;

      beyondUpsellsSlider = new Swiper(".js-beyondupsells-init", {
        slidesPerView: 'auto',
        centeredSlides: false,
        spaceBetween: 0,
        loop: false,
        navigation: {
          nextEl: ".js-beyondupsells-next",
          prevEl: ".js-beyondupsells-prev",
        },
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
      });
    });
  });
}

// Inizializza solo una volta
if (!window.beyondUpsellsInitialized) {
  window.beyondUpsellsInitialized = true;
  
  // Inizializza al caricamento
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBeyondUpsellsSwiper);
  } else {
    initBeyondUpsellsSwiper();
  }

  // Usa il sistema PUB_SUB di Shopify Dawn
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      // Timeout più lungo per dare tempo al quick-add di completare
      setTimeout(initBeyondUpsellsSwiper, 300);
    });
  }
}